import { useContext } from "react";
import { AppContext } from "../contexts/AppContext";

export default function useIsMe(id) {
  const [appState] = useContext(AppContext);
  const { user } = appState;

  return user?._id === id;
}